module.exports = __webpack_public_path__ + "assets/images/11721d7603a38a33de7a7968c9159343.png";